import React, {useState} from "react";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, Table} from "reactstrap";
import User from "../../../../components/fields/User";
import SendFormatEditStatus from "../../../../components/status/SendFormatEditStatus";

const SendFormatEditLog = ({editLog}) => {
    const [modalshow,setModalshow] = useState(false);
    const [resultContent,setResultContent] = useState(null);
    const [resultAnalyze,setResultAnalyze] = useState(null);

    const showLog = (content,analyze) => {
        setResultContent(content);
        setResultAnalyze(analyze);
        setModalshow(true);
    }

    return <>
        {editLog && editLog.length > 0 &&
            <div className="table-responsive">
                <Table>
                    <thead>
                    <tr>
                        <th>Date</th>
                        <th>User</th>
                        <th>Status</th>
                        <th>Description</th>
                        <th>Changes</th>
                    </tr>
                    </thead>
                    <tbody>
                    {editLog.map((editLogItem, index) => {
                        return <tr key={index}>
                            <td>{editLogItem.senddate}</td>
                            <td><User user={editLogItem.user}/></td>
                            <td><SendFormatEditStatus status={editLogItem.prstatus}/></td>
                            <td className="text-truncate">{editLogItem.prompt}</td>
                            <th><button className="btn btn-primary" onClick={()=> showLog(editLogItem.contentfilediff, editLogItem.analyzefilediff)}>View</button></th>
                        </tr>
                    })}
                    </tbody>
                </Table>
            </div>
        }
        <React.Fragment>
            <Modal
                isOpen={modalshow}
                toggle={() => {
                    setModalshow(!modalshow)
                }}
                size="lg"
                onClose={() => setModalshow(!modalshow)}
            >
                <ModalHeader toggle={() => {
                    setModalshow(!modalshow)
                }}>
                    Changes
                </ModalHeader>
                <ModalBody style={{backgroundColor:"#F7F9FC"}}>
                    {resultContent &&
                        <div className="mt-3">
                            <h5>Data</h5>
                            <div
                                dangerouslySetInnerHTML={{ __html: resultContent }}
                            />
                        </div>
                    }
                    {resultAnalyze &&
                        <div className="mt-3">
                            <h5>Result</h5>
                            <div
                                dangerouslySetInnerHTML={{ __html: resultAnalyze }}
                            />
                        </div>
                    }
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => {setModalshow(!modalshow);}}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    </>
}

export default SendFormatEditLog;
